import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OwnershipRoutingModule } from './ownership-routing.module';
import { OwnershipListComponent } from './ownership-list/ownership-list.component';
import { OwnershipCreateComponent } from './ownership-create/ownership-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [OwnershipListComponent, OwnershipCreateComponent],
  imports: [
    CommonModule,
    OwnershipRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class OwnershipModule { }
